import React, {Component} from 'react'

import Popup from '../Popup/index';
import {ROOM_TYPE_PERMANENT} from '../../../constants/rooms';

import Registry from '../../../registry/index';

class RoomInfoTooltip extends Popup {
    position() {
        if (!this.$anchor || this.$anchor.length === 0) return;

        var offset = this.$anchor.offset(),
        // popupWidth = this.$popup.width(),
            anchorWidth = this.$anchor.width(),
            anchorHeight = this.$anchor.height();

        this.$popup.css({
            left: (offset.left + anchorWidth / 4 /*- popupWidth / 2*/) + "px",
            top: (offset.top + anchorHeight + 8) + "px"
        });
    }

    open() {
        this.position();
        this.$popup.css({
            display: "block",
            opacity: 0
        }).animate({opacity: 1}, 300);
    }

    close() {
        this.$popup.css({
            display: "none",
            opacity: 0
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.anchor) this.setAnchor(nextProps.anchor);
    }

    formatRoomCreatedOffset(lang, offset) {
        var days = parseInt(offset / 86400),
                hours = parseInt((offset % 86400) / 3600),
                mins = parseInt((offset % 3600) / 60);

        var DHM = lang.DHM;

        var daysString = DHM[0] || "j",
            hoursString = DHM[1] || "h",
            minsString = DHM[2] || "mn";

        return (days ? ((days < 10 ? "0" + days : days) + " " + daysString + " ") : "") +
                (hours ? ((hours < 10 ? "0" + hours : hours) + " " + hoursString + " ") : "") +
                ((mins < 10 ? "0" + mins : mins) + " " + minsString);
    }

    renderPermanentRoom() {
        let {room} = this.props;
        if (!room.description) return null;
        return (
            <div className="popup-room-info" ref={(ref) => this._ref = ref}>
                {room.description}
            </div>
        )
    }

    render() {
        let lang = Registry.get('locale');

        let {room} = this.props;
        if (room.type === ROOM_TYPE_PERMANENT) return this.renderPermanentRoom();

        var createdDate = new Date(room.created * 1000),
            currentTimeUTC = (new Date()).getTime(),
            offset = (currentTimeUTC - createdDate.getTime()) / 1000,
            offsetFormatted = this.formatRoomCreatedOffset(lang, offset);

        // let className = 'popup-room-info '; /* + this.state.visibility; */

        return (
            <div className="popup-room-info" ref={(ref) => this._ref = ref}>
                <div className="room-name">{room.roomid}</div>
                {lang.room_info_created_by} <span className="created_by">{room.creator_nick}</span><br/>
                {lang.room_info_there_is} <span className="there_is">{offsetFormatted}</span>
            </div>
        )
    }
}

RoomInfoTooltip.defaultProps = {
    room: {created: 0, creator_nick: ''}
};

RoomInfoTooltip.generateKey = function(props) { return 'room-info-tooltip' };
RoomInfoTooltip.mount = function(props, onMount) { return Popup.mount(RoomInfoTooltip, props, onMount) };

export default RoomInfoTooltip;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomInfoTooltip/index.js